import { convertToDateTime } from "../bp-mobile.utils";
import { BpMobileNotification } from "@libs/api/gateways/bp-mobile/bp-mobile.dtos";
import { NotificationFormValues } from "./NotificationForm";

export const getValidNotificationDateAndTimeMessage = (options: {
  notificationStartDate: Date | undefined;
  notificationStartTime: string | undefined;
  notificationEndDate: Date | undefined;
  notificationEndTime: string | undefined;
}): string | undefined => {
  const {
    notificationStartDate,
    notificationStartTime,
    notificationEndDate,
    notificationEndTime
  } = options;
  if (
    !(
      notificationStartDate &&
      notificationStartTime &&
      notificationEndDate &&
      notificationEndTime
    )
  )
    return undefined;

  const notificationStartDateTime = convertToDateTime(
    notificationStartDate,
    notificationStartTime
  );

  const notificationEndDateTime = convertToDateTime(
    notificationEndDate,
    notificationEndTime
  );

  if (notificationStartDateTime >= notificationEndDateTime) {
    return "Notification start date and time must be before notification end date and time.";
  }

  return undefined;
};

export const parseNotification = (
  notification?: BpMobileNotification
): NotificationFormValues => {
  return {
    ...notification,
    notificationTimeStartUtc: notification?.startTime?.toTimeInputFormat(),
    notificationTimeEndUtc: notification?.endTime?.toTimeInputFormat(),
    notificationDateStartUtc: notification?.startTime?.toJSDate(),
    notificationDateEndUtc: notification?.endTime?.toJSDate(),
    outageMessage: notification?.outageMessage
  };
};
